export class WatermarkingConfigurationModel {
  public id: number;
  public heartbeatMin: number;
  public minTimeCodeDrift: number;
  public maxTimeCodeDrift: number;
  public nbEvent: number;
  public nbRestartAlarm: number;
  public technology: string;

  constructor() {
    this.id = 0;
    this.heartbeatMin = 0;
    this.maxTimeCodeDrift = 0;
    this.minTimeCodeDrift = 0;
    this.nbEvent = 0;
    this.nbRestartAlarm = 0;
    this.technology = "";
  }
}
